module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-office-contest"
  }, [_c('div', {
    staticClass: "custom-office-contest__container"
  }, [_c('div', {
    staticClass: "custom-office-contest__row"
  }, [_c('div', {
    staticClass: "custom-office-contest__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-office-contest__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-office-contest__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.pdf_url) ? _c('a', {
    staticClass: "custom-office-contest__imgwrap",
    attrs: {
      "href": _vm.props.pdf_url,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-office-contest__img",
    attrs: {
      "src": _vm.props.image,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "custom-office-contest__imgwrap"
  }, [_c('img', {
    staticClass: "custom-office-contest__img",
    attrs: {
      "src": _vm.props.image,
      "alt": ""
    }
  })]), _c('a', {
    staticClass: "custom-office-contest__imgwrap",
    attrs: {
      "href": _vm.props.pdf_url,
      "target": "_blank"
    }
  }, [(_vm.props.image2) ? _c('img', {
    staticClass: "custom-office-contest__img",
    attrs: {
      "src": _vm.props.image2,
      "alt": ""
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69106133","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-office-contest/custom-office-contest.pug
// module id = 648
// module chunks = 1